import { useQuery } from 'react-query';
import { CategoryResponse } from './categoryTypes';
import { getCategoryById } from './categoryService';

type Props<M> = {
    id: string;
    onError?: (error: Error) => void;
    onSuccess?: (data: CategoryResponse) => void;
    mapper?: (data?: CategoryResponse) => M | CategoryResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: CategoryResponse) => data;

export const useGetCategory = <M = CategoryResponse>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
    id,
}: Props<M>) => {
    const query = useQuery<CategoryResponse, Error>(
        ['category', id],
        () => getCategoryById(id),
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
